import * as React from 'react';
import '../css/card.sass';
import StaticElementButton from './StaticElementButton';
import MultipleMessagesPopup from './MultipleMessagesPopup';

export interface HatType {
  type: 'info' | 'warning' | 'error' | 'success' | 'highlight' | 'default';
  id?: string;
  message: React.ReactNode;
}
interface HatProps {
  hat: HatType[];
  theme?: 'night' | 'day';
}

interface HatState {
  displayMessagesPopup: boolean;
  seeMore: boolean;
}

export default function Hat(props: HatProps) {
  const twoLinesHeight = 70;
  const hatRef: any = React.useRef();
  const hatContentRef: any = React.useRef();
  const checkHatSize = () => {
    return hatRef.current && hatRef.current.offsetHeight > twoLinesHeight;
  };
  const { theme = 'day' } = props;
  const [state, setState] = React.useState<HatState>({
    displayMessagesPopup: false,
    seeMore: checkHatSize()
  });

  const innerHtmlChanged = () => {
    if (checkHatSize() && !state.seeMore) {
      setState({ ...state, seeMore: true });
    }
  };

  if (hatContentRef.current) {
    hatContentRef.current.addEventListener(
      'DOMSubtreeModified',
      innerHtmlChanged
    );
  }

  React.useEffect(() => {
    if (checkHatSize() && !state.seeMore) {
      setState({ ...state, seeMore: true });
    }
  }, []);

  const handleMultipleMessage = () => {
    setState({ ...state, displayMessagesPopup: true });
  };

  return (
    <>
      <div style={{ position: 'relative' }}>
        {props.hat && props.hat.length === 1 && (
          <div
            ref={hatRef}
            id={props.hat[0].id}
            className={`hat ${props.hat[0].type} ${theme}`}
          >
            <div ref={hatContentRef} className="hatContent">
              {state.seeMore ? (
                <>
                  <div className="ellipsis">{props.hat[0].message}</div>
                  <br />
                  <StaticElementButton
                    name="seemoremessagebtn"
                    id="seemoremessagebtn"
                    label="See More"
                    type="div"
                    onClick={() => {
                      setState({ ...state, displayMessagesPopup: true });
                    }}
                  >
                    See More
                  </StaticElementButton>
                </>
              ) : (
                props.hat[0].message
              )}
            </div>
          </div>
        )}
        {props.hat && props.hat.length > 1 && (
          <div className="hat multiple">
            <span className="icon" />
            <StaticElementButton
              name="seemultimessagesbtn"
              id="seemultimessagesbtn"
              label="See Multiple Messages"
              type="div"
              onClick={handleMultipleMessage}
            >
              See Multiple Messages
            </StaticElementButton>
          </div>
        )}
      </div>
      {state.displayMessagesPopup && (
        <MultipleMessagesPopup
          messages={props.hat}
          onClose={() => setState({ ...state, displayMessagesPopup: false })}
        />
      )}
    </>
  );
}
